import { render } from "./ColModal.vue?vue&type=template&id=cf9493d0"
import script from "./ColModal.vue?vue&type=script&lang=js"
export * from "./ColModal.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__